import React from "react";
import { useIntl } from "react-intl";

import TableHeader from "../../../components/app/generic/tableHeader";

const ChangePasswordHeader = () => {
  const intl = useIntl();
  return (
    <TableHeader
      title={intl.formatMessage({
        id: "user.passwordChange",
        defaultMessage: "Změna hesla",
      })}
    />
  );
};

export default ChangePasswordHeader;
